import React from "react";

export function PlayButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#fff"
        d="M8.5 14.584V7.416a.5.5 0 01.77-.42l5.576 3.583a.5.5 0 010 .842L9.27 15.005a.5.5 0 01-.77-.42z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 1.5a9.5 9.5 0 100 19 9.5 9.5 0 000-19zM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}